/* eslint-disable @next/next/no-img-element */
import React from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import HomeIpCreationEntry from '@/pages/--roboneo/home/components/HomeIpCreationEntry';
import { useMyIpCreationCopy } from '$/pages/RoboneoMyIps/useMyIpCreationCopy';
import ipCardAvatar from './assets/ip-card-avatar.jpg';
import style from './index.module.scss';

/** 渲染未登录态的角色 IP 与画布创建入口。 */
export default function NotLoginIpProject() {
  const { home } = useMyIpCreationCopy();
  const languageStore = useLanguageStore((s) => s.languageStore);
  const toLogin = useOfficialStore((state) => state.toLogin);

  /** 调起账号登录弹窗，用户主动关闭时不产生未处理的 Promise 拒绝。 */
  const handleLogin = () => {
    toLogin().catch(() => {});
  };

  return (
    <section className={style.not_login_ip_project_container}>
      <HomeIpCreationEntry className={style.ipCard}>
        <span className={style.createVisual} aria-hidden="true">
          <span className={style.avatarFrame}>
            <img src={ipCardAvatar.src} alt="" draggable={false} />
          </span>
          <span className={style.plusFrame}>
            <IconFont name="plusBlack" fontSize={16} />
          </span>
        </span>
        <div className={style.cardLabel}>{home.createPromotion}</div>
      </HomeIpCreationEntry>

      <div className={style.canvasCard} onClick={handleLogin}>
        <span className={style.dotPattern} aria-hidden="true" />
        <span className={style.canvasCardIcon} aria-hidden="true">
          <IconFont name="plusFill" fontSize={20} />
        </span>
        <div className={style.cardLabel}>
          {languageStore.smartcatTranslationText((v) => v.create_new_projects)}
        </div>
      </div>
    </section>
  );
}
